export { default } from './Wysiwyg';
